export { Duplicate as default } from './Duplicate';
